export const WINDOW_WIDTH_CHANGED = 'domevents/DOM_EVENTS_WINDOW_WIDTH_CHANGED';
